export const TAB_IDS = {
  EMAILS: "emails",
  ALERTS: "alerts",
  ACTIVITY: "activity",
  SETTINGS: "settings"
};
